var OrderValidationResponse = {
  "OrderCode": "3DRNJ",
  "Store": "1020",
  "NetAmountWithNoTax": 6.99,
  "OrderLines": [{
    "CartLineItem": 1,
    "OriginalAmount": 3.99,
    "Amount": 0.00,
    "Description": "Plain Hot Latte",
    "Quantity": 1,
    "PosItemId": "900000251",
    "PosProductGroupType": "Restaurant"
  }, {
    "CartLineItem": 2,
    "OriginalAmount": 4.99,
    "Amount": 0.00,
    "Description": "Pancakes (2) Brk Opt",
    "Quantity": 1,
    "PosItemId": "RP00096",
    "PosProductGroupType": "Restaurant"
  }, {
    "CartLineItem": 3,
    "Amount": 4.99,
    "Description": "French Toast (2) Brk",
    "Quantity": 1,
    "PosItemId": "pos-486073",
    "PosProductGroupType": "Restaurant"
  }, {
    "CartLineItem": 4,
    "Amount": 4.49,
    "Description": "Biscuit Beignet (6) BarrelBites",
    "Quantity": 1,
    "PosItemId": "pos-486074",
    "PosProductGroupType": "Restaurant"
  }, {
    "CartLineItem": 5,
    "Amount": 3.49,
    "Description": "Seasonal Fruit (BrkOpt)",
    "Quantity": 1,
    "PosItemId": "pos-486075",
    "PosProductGroupType": "Restaurant"
  }],
  "Success": true,
  "Tax": 0.88,
  "PreCheck": "",
  "TotalToPay": 7.87
};
export { OrderValidationResponse };